import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const AppleDevice169: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>
        {
          '.apple16-9_svg__cls-1{fill:#fff}.apple16-9_svg__cls-2{fill:none;stroke:#f5f5f5;stroke-miterlimit:10}.apple16-9_svg__cls-3{fill:#9e9e9e}.apple16-9_svg__cls-6{fill:#e5e5e5}.apple16-9_svg__cls-8{fill:#424242}.apple16-9_svg__cls-9{fill:#eee}'
        }
      </style>
    </defs>
    <g id="apple16-9_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="apple16-9_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          className="apple16-9_svg__cls-1"
          d="M6.28 39.65h131.78v74.42H6.28zM138 39.65v-18a14.29 14.29 0 00-14.25-14.32h-14.1v1.92a7.58 7.58 0 01-7.57 7.59h-59a7.58 7.58 0 01-7.58-7.59V7.33H20.56A14.3 14.3 0 006.28 21.64v18z"
        />
        <path
          className="apple16-9_svg__cls-1"
          d="M6.28 112.23v167a14.31 14.31 0 0014.31 14.31h103.1a14.31 14.31 0 0014.31-14.3v-167z"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <path className="apple16-9_svg__cls-2" d="M6.41 259.03h131.36M6.41 41.38h131.36" />
        <circle className="apple16-9_svg__cls-3" cx={20.18} cy={270.75} r={5.23} />
        <circle className="apple16-9_svg__cls-3" cx={45.34} cy={270.75} r={5.23} />
        <circle cx={70.51} cy={270.75} r={5.23} fill="#1784eb" />
        <circle className="apple16-9_svg__cls-3" cx={95.67} cy={270.75} r={5.23} />
        <circle className="apple16-9_svg__cls-3" cx={120.83} cy={270.75} r={5.23} />
        <rect x={12.08} y={67.33} width={121.35} height={67.25} rx={7.91} fill="#c0ebf9" />
        <rect className="apple16-9_svg__cls-6" x={102.42} y={50.77} width={28.09} height={9.87} rx={4.94} />
        <rect x={13.75} y={22.86} width={116.48} height={11.38} rx={5.69} fill="#e7e7e7" />
        <path className="apple16-9_svg__cls-8" d="M12.98 47.24h15.69v15.69H12.98z" />
        <path className="apple16-9_svg__cls-9" d="M33.33 48.84H67.7v3.94H33.33zM33.33 55.54h22.08v3.94H33.33z" />
        <rect className="apple16-9_svg__cls-6" x={102.42} y={149.56} width={28.09} height={9.87} rx={4.94} />
        <path className="apple16-9_svg__cls-8" d="M12.98 146.04h15.69v15.69H12.98z" />
        <path className="apple16-9_svg__cls-9" d="M33.33 147.63H67.7v3.94H33.33zM33.33 154.33h22.08v3.94H33.33z" />
        <path className="apple16-9_svg__cls-6" d="M12.97 167.27H68.9v80.65H12.97zM73.98 167.27h55.93v80.65H73.98z" />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default AppleDevice169;
